<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import type { MenuItem } from '@/presentation/components/mainmenu/MenuItem.ts';
import SideMenuItem from '@/presentation/components/mainmenu/SideMenuItem.vue';
import SideMenuTooltip from '@/presentation/components/mainmenu/SideMenuTooltip.vue';

const router = useRouter();

const props = defineProps({
  collapsed: Boolean,
});

const tooltipRefBottom = ref(null);
const menuItems: MenuItem[] = [
  {
    name: 'Dashboard',
    translation: { key: 'global.dashboard', params: { count: 1 } },
    icon: 'tachometer-alt',
    clickClosure: () => router.push({ name: 'Dashboard' }),
  },
  {
    name: 'Health',
    translation: { key: 'global.health', params: { count: 1 } },
    icon: 'heartbeat',
    clickClosure: () => router.push({ name: 'Health' }),
  },
  {
    name: 'AllPlants',
    translation: { key: 'glossary.plant', params: { count: 2 } },
    icon: 'solar-panel',
    clickClosure: () => router.push({ name: 'AllPlants' }),
  },
  {
    name: 'PerformancesMonitoring',
    translation: { key: 'glossary.performance', params: { count: 2 } },
    icon: 'file-contract',
    clickClosure: () => router.push({ name: 'PerformancesMonitoring' }),
  },
  {
    name: 'Issues',
    translation: { key: 'glossary.issue', params: { count: 2 } },
    icon: 'bolt',
    clickClosure: () => router.push({ name: 'Issues' }),
  },
  {
    name: 'TicketsPage',
    translation: { key: 'glossary.ticket', params: { count: 2 } },
    icon: 'ticket-alt',
    clickClosure: () => router.push({ name: 'TicketsPage' }),
  },
  {
    name: 'Reports',
    translation: { key: 'global.report', params: { count: 2 } },
    icon: 'file',
    clickClosure: () => router.push({ name: 'Reports' }),
  },
  {
    name: 'AllUsers',
    translation: { key: 'global.user', params: { count: 2 } },
    icon: 'users',
    clickClosure: () => router.push({ name: 'AllUsers' }),
  },
  {
    name: 'Tags',
    translation: { key: 'glossary.tag', params: { count: 2 } },
    icon: 'tags',
    clickClosure: () => router.push({ name: 'Tags' }),
  },
  {
    name: 'Custom Fields',
    translation: { key: 'glossary.custom_fields', params: { count: 2 } },
    icon: 'list-ol',
    clickClosure: () => router.push({ name: 'Custom Fields' }),
  },
];
</script>

<template>
  <ul class="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-track-slate-800">
    <SideMenuItem
      v-for="item in menuItems"
      :item="item"
      :collapsed="props.collapsed"
      @mouseenter="tooltipRefBottom?.onEnter($event, item)"
      @mouseleave="tooltipRefBottom?.onLeave()"/>
  </ul>

  <SideMenuTooltip ref="tooltipRefBottom" :collapsed="props.collapsed"/>
</template>

<style scoped>

</style>